import React, { useState, useEffect, useContext } from 'react';
import { Button, message, Row, Col, Divider, Spin, Space, Checkbox, List, Select, Typography, Modal, Form, InputNumber, Input, Card, Radio } from 'antd';
import AppContext from "../AppContext";
import { ReloadOutlined, PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { onCreateShift, onGetShift, onEditShift } from '../../Controller/Management/ShiftManagement';
import T_Error from "../404";

const { Option } = Select;
const { Meta } = Card;
export default function ShiftManagement(prop) {
    //===== VARIABLE ====
    const global = useContext(AppContext);
    const [shiftlist, setShiftList] = useState([]);
    const [isMaintenance, setIsMaintenance] = useState(false);      // Used for maintenance
    const [btndisable, setBtnDisable] = useState(false);
    const [form] = Form.useForm();
    const [minOTchecked, setminOTchecked] = useState(false);
    // ===== LIST ======
    const [initLoading, setInitLoading] = useState(true);
    //======= MODAL ========
    const [isModalVisible, setIsModalVisible] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [action, setAction] = useState("");
    const [currentworktype, setcurrentworktype] = useState("");

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };
    const formItemLayoutWithOutLabel = {
        wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 20, offset: 6 },
        },
    };
    //====== 20211011 WORK FIXED TIME =======
    //const [workFixed, setWorkFixed]             = useState(1);
    // RADIO GROUP OPTIONS
    // const isworkfixedoptions = [{
    //     value   : 1,
    //     name    : "Fixed"
    // },
    // {
    //     value   : 0,
    // }];

    //===== USE EFFECT ========
    useEffect(() => {
        onRefresh();
    }, []);




    //===== FUNCTION =====
    const onRefresh = () => {
        onGetShift({})
            .then(val => {
                setShiftList(val.data);
                setInitLoading(false);
                setBtnDisable(false);
                return val;
            })
            .catch(err => {
                message.error(err.msg);
                setIsMaintenance(true);
            });

    }

    //==== 20211011 IS WORK FIXED ON CHANGE 
    const onIsWorkFixedChange = () => {

    }

    const onChange = () => {
        let starttime = form.getFieldsValue()?.worktime || "";
        let duration = form.getFieldsValue()?.duration || "";

        if (starttime == "" && duration == "") {
            form.setFieldsValue({
                endworktime: ""
            });
        }
        else {
            let endworktime = Number(starttime) + (Number(duration));
            form.setFieldsValue({
                endworktime: endworktime
            });
        }
    }

    const onCheckedChange = (e) => {
        if (e.target.checked) {
            setminOTchecked(true);
        }
        else {
            //===== SET MINIMUM OT FIELDS =======
            form.setFieldsValue({
                minimumot: ""
            });
            setminOTchecked(false);
        }
    }

    //20210727 add refresh all windows
    const onReload = () => {
        setBtnDisable(true);
        window.location.reload();
    }

    const onFinish = (data) => {
        console.log("save data >>>", data)
        data.hasOT = data.hasOT == undefined ? 0 : data.hasOT == true ? 1 : 0;     // HAS OT
        data.isWFH = data.isWFH == undefined ? 0 : data.isWFH == true ? 1 : 0;     // IS WFH
        data.startworktime = parseFloat(data.worktime) * 3600;


        switch (action) {
            case "create":
                return onCreateShift(data)
                    .then(result => {
                        onRefresh();
                        setIsModalVisible(false);
                    });
            case "edit":
                data.shiftid = data._id;
                return onEditShift(data)
                    .then(result => {
                        onRefresh();
                        form.resetFields()
                        setIsModalVisible(false);
                    });
                break;
            default:
                message.error("unknown operation, check your interface and try again");
                setIsModalVisible(false);
                return;
        }
    }

    //===== FORM =======
    const onShiftProfForm = () => {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        return (
            <Form form={form} onFinish={onFinish} {...formItemLayoutWithOutLabel}>
                {
                    <>
                        {/* ID */}
                        <Form.Item name={"_id"} style={{ display: "none" }}></Form.Item>
                        {/* SHIFT NAME  */}
                        <Form.Item name={"name"} label="Name" rules={[{ required: true, message: "Shift Name is required" }]}
                            {...formItemLayout}>
                            <Input />
                        </Form.Item>
                        {/* WORKING FIXED TIME */}
                        {/* <Form.Item  name={"isworkfixed"} label="Is Flexible"  
                            {...formItemLayout}>
                                <Radio.Group options={isworkfixedoptions} onChange={onIsWorkFixedChange} value={workFixed} />
                        </Form.Item> */}
                        {/* 20210816 - Add start from date worktime */}
                        <Form.Item name={"worktime"} label="Start Work Time" rules={[{ required: false, message: "Start Work Time is required" }]}
                            {...formItemLayout}>
                            <InputNumber min={1} max={24} precision={1} onChange={onChange} />
                        </Form.Item>
                        {/* Jupiter / 20231220 - add work type for shifts, fixed or flexible */}
                        <Form.Item name={"worktype"} label="Work Type" rules={[{ required: false, message: "Work Type is required" }]}
                            {...formItemLayout}>
                            <Select onChange={(e) => setcurrentworktype(e)}>
                                <option value="fixed">Fixed</option>
                                <option value="flexible">Flexible</option>
                            </Select>
                        </Form.Item>
                        {/* 20210812 - Duration */}
                        <Form.Item name={"duration"} label="Duration" rules={[{ required: false, message: "Duration is required" }]}
                            {...formItemLayout}>
                            <InputNumber min={1} max={24} onChange={onChange} />
                        </Form.Item>
                        {
                            //console.log('currentworktype >>>',currentworktype)
                            currentworktype == "flexible" ?
                                /* Jupiter / 20231220 - Working hour per week for flexible work type and work days*/
                                <>
                                    <Form.Item name={"durationperweek"} label="Duration Week" rules={[{ required: false, message: "Duration is required" }]}
                                        {...formItemLayout}>
                                        <InputNumber min={1} max={50} onChange={onChange} />
                                    </Form.Item>

                                    <Form.Item name={"workingdays"} label="Work Days" rules={[{ required: false, message: "Work Days is required" }]}
                                        {...formItemLayout}>
                                        <Select mode="multiple">
                                            <option value="0">Sunday</option>
                                            <option value="1">Monday</option>
                                            <option value="2">Tuesday</option>
                                            <option value="3">Wednesday</option>
                                            <option value="4">Thursday</option>
                                            <option value="5">Friday</option>
                                            <option value="6">Saturday</option>
                                        </Select>
                                    </Form.Item>
                                </>

                                :
                                ""
                        }

                        {/* 20210812 - HasOT */}
                        <Form.Item name={"hasot"} valuePropName="checked" label="Has OT" onChange={onCheckedChange} rules={[{ required: false, message: "CanOT is required" }]}
                            {...formItemLayout}>
                            <Checkbox />
                        </Form.Item>
                        {/* 20210813 - Minimum OT Duration (MINUTES) */}
                        <Form.Item name={"minimumot"} label="Minimum OT" rules={[{ required: minOTchecked, message: "Minimum OT Duration is required" }]}
                            {...formItemLayout}>
                            <InputNumber min={1} disabled={!minOTchecked} />
                        </Form.Item>
                        <Form.Item name={"endworktime"} label="End Work Time" rules={[{ required: false, message: "Minimum OT Duration is required" }]}
                            {...formItemLayout}>
                            <Input disabled />
                        </Form.Item>
                    </>
                }
            </Form>
        )
    }

    const onFilterForm = () => {
        return (
            <>
                <Row gutter={[8, 8]}>
                    <Col span={8}>
                        <Select style={{ width: "100px" }} disabled>
                            <Option value={"oldest"}>Oldest</Option>
                            <Option value={"newest"}>Newest</Option>
                        </Select>
                    </Col>
                </Row>
            </>
        )
    }

    //===== LIST =======
    const renderShiftItem = (item) => {

        return (
            <List.Item
                visible={"false"}
            >
                <Card
                    onClick={() => {
                        item.worktime = Number(item.startworktime) / 60 / 60;
                        item.minimumot = item.minimumot == 0 ? "" : item.minimumot;
                        item.endworktime = Number(item.worktime) + (Number(item.duration));
                        //====== IF HAS OT IS TRUE =====
                        if (item.hasot == 1) {
                            setminOTchecked(true);
                        }
                        setcurrentworktype(item.worktype)
                        form.setFieldsValue(item);
                        showModal('edit');
                    }}
                    hoverable
                    className="list-card-item-BO"
                    style={{
                        minHeight: "100%",
                        borderRadius: "10px",
                        textAlign: "center"
                    }}
                >
                    <Meta
                        title={
                            <font
                                className="gradient-text"
                                style={{
                                    fontSize: '2.50em'

                                }} size="large">
                                {item["name"]}
                            </font>
                        }
                        description={<>
                            <Row justify="center">
                                {/* <Tag color="geekblue">
                                    {data["country"]}
                                </Tag>
                                <Tag color="geekblue">
                                    {data["ip"]}
                                </Tag> */}
                            </Row>
                        </>}
                    />
                </Card>
            </List.Item>
        )
    }

    //====== MODAL ======
    const onShiftModal = () => {
        return (
            <Modal
                title={modalTitle}
                visible={isModalVisible}
                destroyOnClose={true}
                style={{ maxWidth: "80%" }}
                bodyStyle={{ overflow: "auto", maxHeight: "70vh" }}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Submit"
            >
                {onShiftProfForm()}
            </Modal>
        )
    }

    const showModal = (modalAction) => {
        // setModalAction(modalAction);
        switch (modalAction) {
            case "create":
                setAction("create");
                setModalTitle(`New Shift`);
                setIsModalVisible(true);
                break;
            case "edit":
                setAction("edit");
                setModalTitle("Edit Shift");
                setIsModalVisible(true);
                break;
            default:
                message.error("No Action required");
                break;
        }
    }

    const onShiftManagementForm = () => {
        console.log("listproprs", listProps)
        return (
            <>
                <Row justify="start">
                    <Divider>{prop.title ?? "."}</Divider>
                </Row>
                {/* HEADER */}
                {/* BODY */}
                <Row>
                    <Col span={24}>
                        <div style={{ float: "right" }}>
                            <Space size={2}>
                                <Button onClick={() => { showModal("create") }}><PlusOutlined /></Button>
                                <Button onClick={onReload}>{btndisable ? <Spin /> : <ReloadOutlined />}</Button>
                            </Space>
                        </div>

                    </Col>
                </Row>
                {/* {onFilterForm()} */}
                <Row gutter={[8, 8]}>
                    <Col xs={24}>
                        <List {...listProps}></List>
                    </Col>
                </Row>
            </>
        )
    }

    const handleOk = () => {
        form.submit();
    }

    const handleCancel = () => {
        form.resetFields()
        setAction("");
        setminOTchecked(false);
        setIsModalVisible(false);
    }

    //====== PROPS ========
    const listProps = {
        loading: initLoading,
        dataSource: shiftlist,
        itemLayout: "horizontal",
        grid: { gutter: 16, xs: 2, sm: 2, md: 3, lg: 4, xl: 5, xxl: 6 },
        renderItem: renderShiftItem
    }

    return (
        <>
            {(() => {
                if (isMaintenance) {
                    return (<T_Error />)
                }
                else {
                    return (
                        <>
                            {onShiftManagementForm()}
                            {onShiftModal()}
                        </>
                    )
                }
            })()}
        </>
    )
}